import { CoreFieldProps, fieldTypes, RelativityTooltipV2, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { DepositApplicationReadDTO } from "@/types";
import { Icon, Intent } from "@blueprintjs/core";

export interface PositivePayOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface PositivePayOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const PositivePayOptInComplexField: FC<PositivePayOptInComplexFieldProps> = (props) => {
  const positivePayOptInComplexValue = props.complexFieldValue as PositivePayOptInComplexValue;
  const readOnly = positivePayOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container positive-pay-opt-in">
      <SectionHeader
        label={positivePayOptInComplexValue?.headerLabel || props.label}
        hidden={!positivePayOptInComplexValue?.showHeader}
      />
      <div className="complex-field-content">
        <div className="opt-in-v2-switch-container">
          <FieldComplexV2
            {...props}
            complexFieldKey={COMPLEX_FIELD_KEYS.POSITIVE_PAY_OPT_IN.IS_POSITIVE_PAY_OPT_IN_ENABLED}
            complexFieldProps={{
              disabled: readOnly,
            }}
          />
          <RelativityTooltipV2
            shouldShowTooltip={true}
            content={
              "Positive Pay helps prevent check fraud. The bank matches checks presented for payment against the list you provide, allowing you to decide whether to pay or return any exceptions."
            }
          >
            <Icon size={15} icon={"info-sign"} intent={Intent.NONE} />
          </RelativityTooltipV2>
        </div>
        {/* Positive Pay conditional field - show when enabled */}
        {props.formValue?.positivePayOptIn?.isPositivePayOptInEnabled && (
          <div className="opt-ins-form-v2__positive-pay-fields">
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.POSITIVE_PAY_OPT_IN.DEFAULT_POSITIVE_PAY_DECISION}
              complexFieldProps={
                {
                  disabled: readOnly,
                  showClearButton: true,
                } as Partial<CoreFieldProps>
              }
            />
          </div>
        )}
      </div>
    </section>
  );
};
